import { onMounted, onUnmounted } from 'vue'

export function createTimer(callback, interval, reentrant = false) {
    let handle = null
    let abort = false
    let running = 0

    async function run() {
        if (abort) {
            return
        }

        if (running > 0 && !reentrant) {
            return
        }

        running++

        try {
            await callback()
        } finally {
            running--
        }
    }

    function initialize() {
        if (!abort) {
            handle = window.setInterval(run, interval)
        }
    }

    function destroy() {
        abort = true
        if (handle) {
            window.clearInterval(handle)
        }
    }

    onMounted(initialize)
    onUnmounted(destroy)

    return { destroy }
}
